import { render, staticRenderFns } from "./captcha-dialog.vue?vue&type=template&id=0f48e83b&scoped=true"
import script from "./captcha-dialog.vue?vue&type=script&lang=js"
export * from "./captcha-dialog.vue?vue&type=script&lang=js"
import style0 from "./captcha-dialog.vue?vue&type=style&index=0&id=0f48e83b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f48e83b",
  null
  
)

export default component.exports